import request from '@/utils/request';



// 新生预科班列表
export function getPreparatoryCourseListApi() {
    return request({
        url: `/system/study/center/getPreparatoryCourseList`,
        method: 'get',
    })
}